import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Card, FlexView, Button } from 'components/common'
import { TextArea } from 'components/form'
import { TransportContext } from 'stores/ManagementTransportStore'
import styled from 'styled-components'
import { UserContext } from 'stores/UserStore'

const Title = styled.div`
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
`

const SubTitle = styled.div`
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
`

const Label = styled.div`
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
`
const ChangeStatus = ({ isOpen, onOutsideClick, title, status }) => {
    const { resultInformation, changeStatus, validateApprove, solicitacao } = useContext(TransportContext)
    const { currentUser } = useContext(UserContext)
    const { t } = useTranslation()
    const [subtitle, setSubtitle] = useState('')
    const [inputText, setInputText] = useState('')

    useEffect(() => {
        switch (status) {
            case "2":
                setSubtitle(t("transport.informTruckOnRoutForCollect"))
                break
            case "3":
                setSubtitle(t("transport.informTruckWaitingLoad"))
                break
            case "4":
                setSubtitle(t("transport.informTruckOnRout"))
                break
            case "5":
                setSubtitle(t("transport.informTruckUnloaded"))
                break
            default:
                setSubtitle(t("transport.informReverse"))
                break
        }
    }, [status, t])

    const change = async () => {
        let payload = {
            status_from: status,
            user_id: currentUser.id,
            user_name: currentUser.name,
            date: new Date(),
            supplier_transport_request_id: resultInformation.id,
            transport_id: solicitacao,
            shippingCompany: resultInformation.shippingCompany
        }
        switch (title) {
            case 'accept':
                const count = await validateApprove()
                payload = {
                    ...payload,
                    status_to: count === 0 ? 2 : 1,
                    description: inputText !== '' ? `${t(`transport.status.${Number(status) + 1}`)} ${inputText}` : t(`transport.status.${Number(status) + 1}`),
                }
                break
            case 'reverse':
                payload = {
                    ...payload,
                    status_to: Number(status) - 1,
                    description: inputText !== '' ? `${t(`transport.status.${Number(status) - 1}`)} ${inputText}` : t(`transport.status.${Number(status) - 1}`),
                }
                break
            case 'refuse':
                payload = {
                    ...payload,
                    status_to: 8,
                    description: inputText !== '' ? `${t('transport.refuse')} ${inputText}` : t('transport.refuse'),
                }
                break
            default:
                payload = {
                    ...payload,
                    status_to: Number(status) + 1,
                    description: inputText !== '' ? `${t(`transport.status.${Number(status) + 1}`)} ${inputText}` : t(`transport.status.${Number(status) + 1}`),
                }
                break
        }

        await changeStatus(payload)
        setInputText('')
        onOutsideClick()
    }

    const CheckTitle = () => {
        return title === 'accept' || title === 'refuse'
    }

    const Close = () => {
        setInputText('')
        onOutsideClick()
    }

    return <Modal isOpen={isOpen} onOutsideClick={Close}>
        <Card style={{ rowGap: "10px" }} width={CheckTitle() ? '30%' : 'auto'}>
            {CheckTitle() ?
                <Title>{t(`transport.${title}`)} {t('transport.request')}</Title>
                :
                <Title>{t(`transport.${title}`)}</Title>
            }
            {CheckTitle() ?
                <>
                    <Label>{title === "accept" ? "Comentários" : "Motivo: (obrigatório)"}</Label>
                    <TextArea style={{ minHeight: "150px" }} width="100%" value={inputText} onChange={(e) => { setInputText(e.target.value) }} />
                </>
                : <SubTitle>{subtitle}</SubTitle>}
            <FlexView width="100%" flexDirection="row" alignItems="center" justifyContent="flex-end" style={{ columnGap: '15px' }}>
                <Button onClick={() => { setInputText(''); onOutsideClick() }}>
                    {t('transport.cancel')}
                </Button>
                <Button backgroundColor='primary' color='white' disabled={title === "refuse" ? inputText.length < 5 : false} onClick={() => change()}>
                    {t(`transport.${title}`)}
                </Button>
            </FlexView>
        </Card>
    </Modal>
}

export default ChangeStatus
